import { useEffect, useMemo, useState } from 'react';
import { Play, PlayCircle, Settings as SettingsIcon } from 'lucide-react';
import { t, subscribeLanguage } from '../i18n';
import { hasProgress } from '../game/systems/progress';

export default function StartScreen({ onPlay, onContinue, onSettings }) {
  const [, force] = useState(0);
  const canContinue = useMemo(() => hasProgress(), [/* re-eval on mount */]);
  useEffect(() => subscribeLanguage(() => force((n) => n + 1)), []);

  const bubbles = useMemo(
    () => Array.from({ length: 24 }).map((_, i) => ({
      left: Math.random() * 100,
      size: 6 + Math.random() * 22,
      delay: Math.random() * 8,
      duration: 8 + Math.random() * 10,
      opacity: 0.15 + Math.random() * 0.4,
      key: i,
    })),
    []
  );

  return (
    <div data-testid="start-screen" className="neon-screen">
      <div className="neon-ocean-bg">
        <div className="neon-ray neon-ray-1" />
        <div className="neon-ray neon-ray-2" />
        <div className="neon-ray neon-ray-3" />
        {bubbles.map((b) => (
          <span
            key={b.key}
            className="neon-bubble"
            style={{
              left: `${b.left}%`,
              width: b.size,
              height: b.size,
              opacity: b.opacity,
              animationDelay: `${b.delay}s`,
              animationDuration: `${b.duration}s`,
            }}
          />
        ))}
      </div>

      <div className="neon-start-content">
        <h1 data-testid="start-title" className="neon-title">{t('start.title')}</h1>
        <p data-testid="start-subtitle" className="neon-subtitle">{t('start.subtitle')}</p>

        <div className="neon-menu-buttons">
          <button
            data-testid="btn-play"
            onClick={onPlay}
            className="neon-btn neon-btn-primary"
          >
            <Play size={20} />
            <span>{t('common.play')}</span>
          </button>

          <button
            data-testid="btn-continue"
            onClick={onContinue}
            disabled={!canContinue}
            className="neon-btn neon-btn-secondary"
          >
            <PlayCircle size={20} />
            <span>{t('common.continue')}</span>
          </button>

          <button
            data-testid="btn-settings"
            onClick={onSettings}
            className="neon-btn neon-btn-ghost"
          >
            <SettingsIcon size={20} />
            <span>{t('common.settings')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
